// Import
import Vue from 'vue';
import Router from 'vue-router';
import Paths from './paths/index';

// Use Vue Router
Vue.use(Router);

// Start Vue Router
const router = new Router({
  mode: 'history', // Descomenta esta línea para habilitar el modo de historial
  routes: [
    ...Paths,
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else if (to.hash) {
      return {
        selector: to.hash,
        behavior: 'smooth',
      };
    } else {
      return { x: 0, y: 0 };
    }
  },
});

// Middleware
router.beforeEach((to, from, next) => {
  if ((to.path === '/login/' || to.path === '/login' || to.name == 'login')) {
    if(validatePartnerSession()) {
      return next('/admin');
    }
  }

  if (to.matched.some((route) => route.meta && route.meta.requiresAuth)) {
    if (!validatePartnerSession()) {
      return next({ path: '/login', query: { redirect: to.fullPath } });
    }
  }

  next();
});

// Método para validar la sesión de Partner
function validatePartnerSession() {
  const adminToken = localStorage.getItem('adminToken');
  const adminTokenTime = localStorage.getItem('adminTokenTime');

  if (adminToken && adminTokenTime) {
    const currentTime = new Date().getTime();
    const sessionPartnerTimestamp = parseInt(adminTokenTime, 10);
  
    // Verificar si el token ha expirado (más de 3 horas)
    if (currentTime - sessionPartnerTimestamp > 10800000) {
      localStorage.removeItem('adminToken');
      localStorage.removeItem('adminTokenTime');
      return false;
    }

    return true;
  }

  return false; // Si la sesión de partner es válida
}

// Export
export default router;
